import elementService from "@/common/ElementService";

export class MenuToggleVisibilityEvent extends Event {
    public static readonly Type = "menu-toggle-visibility";

    constructor(public readonly isVisible: boolean) {
        super(MenuToggleVisibilityEvent.Type);
    }
}

export default new class MenuOverlayService extends EventTarget {
    private overlay: HTMLDivElement | undefined;

    public showOverlay(onClick: () => void): void {
        const overlay = this.getOrCreateOverlay();
        overlay.addEventListener("click", onClick);

        document.body.classList.add("menuactive", "menu");

        this.dispatchEvent(new MenuToggleVisibilityEvent(true));
    }

    public hideOverlay(): void {
        if (this.overlay === undefined) {
            return;
        }

        document.body.classList.remove("menuactive", "menu");
        this.overlay.remove();
        this.overlay = undefined;

        this.dispatchEvent(new MenuToggleVisibilityEvent(false));
    }

    private getOrCreateOverlay(): HTMLDivElement {
        this.overlay ??= this.createOverlayElement();

        return this.overlay;
    }

    private createOverlayElement(): HTMLDivElement {
        const searchContainer = elementService.querySelector<HTMLDivElement>("#js-search-container");

        const overlayElement = document.createElement("div");
        overlayElement.classList.add("menudrop", "modal");

        searchContainer.appendChild(overlayElement);

        return overlayElement;
    }
}();
